/**
 * A phone or a tablet: a finger for a pointer and nothing to hover with
 * (ADR 0043). The CSS asks the same question with the same media query, so
 * a laptop with a touch screen keeps its mouse layout.
 */
export const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

export function isTouch(): boolean {
  return window.matchMedia(TOUCH_QUERY).matches;
}

/**
 * Runs `listener` now and whenever the device changes kind (a tablet docked
 * to a keyboard and mouse, the browser's device emulation). Returns the
 * unsubscribe.
 */
export function onTouchChange(listener: (touch: boolean) => void): () => void {
  const query = window.matchMedia(TOUCH_QUERY);
  const handle = (): void => {
    listener(query.matches);
  };
  handle();
  query.addEventListener('change', handle);
  return () => {
    query.removeEventListener('change', handle);
  };
}
